import { createColumns } from './columnGroupCreator'
import { selectColumnId } from './myProductColumnIds'

import { TableDateCell } from '../components/tableCells/TableDateCell'
import { MoySkladIdCell } from '../components/tableCells/MoySkladIdCell'
import { TableSelectCell } from '../components/tableCells/TableSelectCell'
import { YandexMarketOrderSyncLogsCell } from '../components/tableCells/StoreOrderSyncLogsCell'
import { YandexMarketOrderCommissionsCell } from '../components/tableCells/OrderCommissionsCell'
import { YandexMarketOrderSyncErrorCell } from '../components/tableCells/YandexMarketOrderSyncErrorCell'

import { tableCellStyles } from '../hooks/tableStylesHook'

import { formatPrice } from '../common/numberUtils'

import { YandexMarketAccountModel } from '../server/mpsklad_core/Models/YandexMarketAccountModel'
import { YandexMarketOrderModel } from '../server/mpsklad_core/Models/Orders/YandexMarketOrderModel'

export type YandexMarketOrderColumnId =
  keyof YandexMarketOrderModel
  | typeof selectColumnId
  | 'moySkladId'
  | 'logs'

export const createYmOrderColumns =
  (ymAccount: YandexMarketAccountModel) =>
    createColumns<YandexMarketOrderColumnId, YandexMarketOrderModel>({
      id: selectColumnId,
      title: 'Выбрать',
      CellComponent: TableSelectCell
    }, {
      id: 'id',
      title: 'Id'
    }, {
      id: 'createdAt',
      title: 'Дата создания',
      CellComponent: TableDateCell
    }, {
      id: 'yandexMarketOrderId',
      title: 'Id в Yandex.Market'
    }, {
      id: 'items',
      title: 'Товары',
      accessor: _ => _.items.map(p => `${p.shopSku} - ${p.offerName} (${p.count})`)
    }, {
      id: 'price',
      title: `Цена продажи, ${ymAccount.currencySymbol}`,
      accessor: _ => formatPrice(_.price),
      cellStyle: tableCellStyles.noWrap
    }, {
      id: 'status',
      title: 'Статус'
    }, {
      id: 'moySkladId',
      title: 'GUID в МоёмСкладе',
      CellComponent: MoySkladIdCell
    }, {
      id: 'commissionFee',
      title: `Расходы, ${ymAccount.currencySymbol}`,
      CellComponent: YandexMarketOrderCommissionsCell
    }, {
      id: 'syncErrorId',
      title: 'Ошибки',
      CellComponent: YandexMarketOrderSyncErrorCell
    }, {
      id: 'logs',
      title: 'Логи',
      CellComponent: YandexMarketOrderSyncLogsCell
    })